import React, { ReactElement, useState } from 'react'
import { ArtData } from '@/database/art'
import Link from 'next/link'
import { cidv1FromCidv0Url, shortenAddress, shortenUrl } from '@/utils/shortenAddress'
import { listing } from '@/utils/mapping'
import Image from 'next/image'
import { copyToClipboard } from '@/utils/extras'
import { formatDate, formatDateString } from '@/utils/formatting'

const DetailsOverview = ({ artData }: { artData: ArtData | undefined }): ReactElement => {
    const [showTooltip, setShowTooltip] = useState(false)
    const [showTooltip2, setShowTooltip2] = useState(false)

    return (
        <div>
            {artData && (
                <div>
                    <p className="gray">
                        Art:&nbsp;<span className="white">#{artData.art.id}</span>
                    </p>
                    <p className="gray">
                        Original media:&nbsp;<></>
                        <span>
                            {artData.image?.url ? (
                                <span>
                                    <Image
                                        src="/hexagon-copy.svg"
                                        alt="arrow"
                                        width={15}
                                        height={15}
                                        style={{
                                            marginLeft: '1px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => copyToClipboard(artData.image.url, setShowTooltip)}
                                    />
                                    &nbsp;
                                    <Link href={cidv1FromCidv0Url(artData.image.url)}>
                                        <span className="white">{shortenUrl(artData.image.url)}</span>
                                        <span
                                            style={{
                                                visibility: showTooltip ? 'visible' : 'hidden',
                                                opacity: showTooltip ? 1 : 0,
                                                transition: 'opacity 0.5s ease-in-out',
                                            }}
                                        >
                                            &nbsp;Copied!
                                        </span>
                                    </Link>
                                </span>
                            ) : (
                                '-'
                            )}
                        </span>
                    </p>
                    <p className="gray">
                        Metadata:&nbsp;<></>
                        <span>
                            {artData.nft?.metadataUri ? (
                                <span>
                                    <Image
                                        src="/hexagon-copy.svg"
                                        alt="arrow"
                                        width={15}
                                        height={15}
                                        style={{
                                            marginLeft: '1px',
                                            cursor: 'pointer',
                                        }}
                                        onClick={() => copyToClipboard(artData.nft?.metadataUri, setShowTooltip)}
                                    />
                                    &nbsp;
                                    <Link href={cidv1FromCidv0Url(artData.nft.metadataUri)}>
                                        <span className="white">{shortenUrl(artData.nft.metadataUri)}</span>
                                        <span
                                            style={{
                                                visibility: showTooltip ? 'visible' : 'hidden',
                                                opacity: showTooltip ? 1 : 0,
                                                transition: 'opacity 0.5s ease-in-out',
                                            }}
                                        >
                                            &nbsp;Copied!
                                        </span>
                                    </Link>
                                </span>
                            ) : (
                                '-'
                            )}
                        </span>
                    </p>
                    <p className="gray">
                        Title:&nbsp;<span className="white">{artData.art.title}</span>
                    </p>
                    <p className="gray">
                        <span>Description:&nbsp;</span>
                        <span className="white">{artData.art.prompt}</span>
                    </p>
                    <p className="gray">
                        Listing:&nbsp;<span className="white">{listing(artData)}</span>
                    </p>
                    <p className="gray">
                        <span>Owner:&nbsp;</span>
                        <span className="white">{shortenAddress(artData.art.currentOwner)}</span>
                    </p>
                    <p className="gray">
                        Creator:&nbsp;
                        <Image
                            src="/hexagon-copy.svg"
                            alt="arrow"
                            width={15}
                            height={15}
                            style={{
                                marginLeft: '1px',
                                cursor: 'pointer',
                            }}
                            onClick={() => copyToClipboard(artData.art.user.walletAddress, setShowTooltip2)}
                        />
                        &nbsp;
                        <span className="white">{shortenAddress(artData.art.user.walletAddress)}</span>
                        <span
                            style={{
                                visibility: showTooltip2 ? 'visible' : 'hidden',
                                opacity: showTooltip2 ? 1 : 0,
                                transition: 'opacity 0.5s ease-in-out',
                            }}
                        >
                            &nbsp;Copied!
                        </span>
                    </p>
                    <p className="gray">
                        <span>Created&nbsp;at:&nbsp;</span>
                        <span className="white">{formatDateString(artData.art.createdAt)}</span>
                    </p>
                    {artData.nft?.tokenId && artData.nft.tokenId > 0 && (
                        <p className="gray">
                            <span>Minted&nbsp;at:&nbsp;</span>
                            <span className="white">{artData.nft.mintedAt && formatDate(artData.nft.mintedAt)}</span>
                        </p>
                    )}
                </div>
            )}
        </div>
    )
}

export default DetailsOverview
